import InitializeAssetsController from '../../modals/intialize-assets.controller';

export const PlanFormAssetsDirective = () => {
  return {
    restrict: 'E',
    template: require('./assets.html'),
    transclude: true,
    scope: {
      plan: '=',
      assets: '=?'
    },
    controller: 'PlanFormAssetsController'
  };
};

export const PlanFormAssetsController = ($scope, $uibModal, $filter, gettextCatalog, MaintenanceService) => {
  'ngInject';

  //Public
  $scope.error = {};
  $scope.error.equipment = false;
  $scope.confirmed = false;
  $scope.existsAssets = false;
  $scope.assetSelected = false;
  $scope.filteredAssets = [];
  $scope.serviceReadings = [];
  $scope.currentPage = 1;
  $scope.itemsPerPage = 8;
  $scope.maxSize = 1;
  $scope.predicate = 'name';
  $scope.reverse = false;
  $scope.datepickerFormat = 'M/d/yy';
  $scope.loadingServiceReadings = false;
  $scope.orderBy = function (predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;
  };

  $scope.applyFilter = function () {
    if (!$scope.assets) return;
    $scope.filteredAssets = $filter('filter')($scope.assets, $scope.searchText);
  };

  $scope.addAssets = function () {
    $scope.errorFlag = false;
    let modalInstance = $uibModal.open({
      animation: true,
      template: require('../../../../../components/assetpicker/asset.multi.picker.html'),
      controller: 'AssetMultiPickerController',
      size: 'lg',
      resolve: {
        singleSelect: false,
        requiresSelection: true,
        maxSelection: function () {
          return 0;
        },
        selectedAssets: () => {
          let obj = {};
          $scope.assets.forEach(asset => {
            obj[asset.id] = asset;
          });
          return obj;
        }
      }
    });

    modalInstance.result.then(
      function (selectedAssets) {
        if ((selectedAssets.added && selectedAssets.added.length > 0) && selectedAssets.removed.length === 0) {
          $scope.openServiceModal(selectedAssets);
        }
        else if ((selectedAssets.removed && selectedAssets.removed.length > 0) && selectedAssets.added.length === 0) {
          removeAssetsFromPlan(selectedAssets);
        }
        else if (selectedAssets.added.length > 0 && selectedAssets.removed.length > 0) {
          $scope.openServiceModal(selectedAssets);
        }
      },
      function () { }
    );
  };

  $scope.openServiceModal = selectedAssets => {
    $scope.error.equipment = false;
    $scope.errorFlag = false;

    let modalInstance = $uibModal.open({
      animation: true,
      size: 'lg',
      template: require('./add-asset.html'),
      controller: InitializeAssetsController,
      resolve: {
        selected: function () {
          return selectedAssets;
        }
      }
    });

    modalInstance.result.then(function (result) {
      if (result.selectedAssets.removed && result.selectedAssets.removed.length > 0) {
        removeAssetsFromPlan(result.selectedAssets);
      }

      let addedEquipmentChangeSet = {
        op: 'add',
        values: []
      };

      if (result.assets.length > 0) {
        for (let j in result.assets) {
          if (result.setDateForAll === true) {
            addedEquipmentChangeSet.values.push({
              equipmentId: result.assets[j].asset.id,
              initializeWith: {
                odometer: result.assets[j].serviceReading.odometer,
                runhour: result.assets[j].serviceReading.runhour,
                date: result.defaultServiceDate
              }
            });
          } else {
            addedEquipmentChangeSet.values.push({
              equipmentId: result.assets[j].asset.id,
              initializeWith: result.assets[j].serviceReading
            });
          }
        }
        addAssetsToPlan(addedEquipmentChangeSet);        
      }
    });
  };

  function addAssetsToPlan(addedEquipmentChangeSet) {
    MaintenanceService.updateEquipmentForPlan($scope.plan, addedEquipmentChangeSet)
      .then(function () {
        return MaintenanceService.getEquipmentForPlan($scope.plan);
      })
      .then(function (response) {
        $scope.assets = [];
        $scope.existsAssets = false;
        $scope.assetSelected = false;
        _.forEach(response.data, function (asset) {
          $scope.assets.push(asset);
        });
        $scope.filteredAssets = $scope.assets.slice();
        $scope.applyFilter();
        if ($scope.assets.length > 0) $scope.existsAssets = true;
      })
      .catch(function () {
        $scope.errorText = gettextCatalog.getString(
          'An error occurred while trying to add assets to the maintenance plan.'
        );
        $scope.errorFlag = true;
        $scope.loading = false;
      });
  }

  function removeAssetsFromPlan(selectedAssets) {
    let removedEquipmentChangeSet = { op: 'remove', values: [] };
    selectedAssets.removed.forEach((removedAsset) => {
      removedEquipmentChangeSet.values.push({
        equipmentId: removedAsset
      });
    });
    MaintenanceService.updateEquipmentForPlan($scope.plan, removedEquipmentChangeSet)
      .then(function () {
        return MaintenanceService.getEquipmentForPlan($scope.plan);
      })
      .then(function (response) {
        $scope.assets = [];
        $scope.existsAssets = false;
        $scope.assetSelected = false;
        response.data.forEach((asset) => {
          $scope.assets.push(asset);
        });
        $scope.filteredAssets = $scope.assets.slice();
        $scope.applyFilter();
        $scope.existsAssets = $scope.assets.length > 0;
      })
      .catch(function (error) {
        $scope.errorText = gettextCatalog.getString(
          'An error occurred while trying to remove assets from the maintenance plan'
        );
        $scope.errorFlag = true;
        $scope.loading = false;
      });
  }


  $scope.assetClicked = function () {
    let count = 0;
    for (let i = 0; i < $scope.assets.length; i++) {
      if ($scope.assets[i]._selected) {
        $scope.assetSelected = true;
      } else {
        count++;
      }
      if (count === $scope.assets.length) {
        $scope.assetSelected = false;
      }
    }
  };

  $scope.removeSelectedButtonPressed = function () {
    $scope.errorFlag = false;
    $scope.error.equipment = false;
    let equipmentChangeSet = {
      op: 'remove',
      values: []
    };
    let updatedAssets = [];

    for (let i in $scope.assets) {
      if ($scope.assets[i]._selected) {
        $scope.assetSelected = true;
        equipmentChangeSet.values.push({
          equipmentId: $scope.assets[i].id
        });
      } else {
        updatedAssets.push($scope.assets[i]);
      }
    }
    if (
      equipmentChangeSet.values.length !== 0 &&
      equipmentChangeSet.values.length === $scope.assets.length &&
      !$scope.confirmed
    ) {
      $scope.error.equipment = true;
      $scope.error.Msg = gettextCatalog.getString('You must have at least one Asset per configuration.');
      $scope.loading = false;
      return;
    }
    $scope.loading = true;

    MaintenanceService.updateEquipmentForPlan($scope.plan, equipmentChangeSet)
      .then(function () {
        $scope.assetSelected = false;
        $scope.assets = updatedAssets;
        $scope.filteredAssets = $scope.assets.slice();
        $scope.applyFilter();
        if ($scope.assets.length > 0) {
          $scope.existsAssets = true;
        } else {
          $scope.existsAssets = false;
        }
        $scope.loading = false;
      })
      .catch(function () {
        $scope.errorText = gettextCatalog.getString('An error occurred while retrieving tasks');
        $scope.errorFlag = true;
        $scope.loading = false;
      });
  };

  $scope.$watch('plan', function () {
    if ($scope.plan) {
      if ($scope.plan.id) {
        $scope.loading = true;
        $scope.existsAssets = false;
        MaintenanceService.getEquipmentForPlan($scope.plan)
          .then(function (response) {
            $scope.assets = response.data || [];
            $scope.filteredAssets = $scope.assets.slice();
            $scope.applyFilter();
            if ($scope.assets.length > 0) $scope.existsAssets = true;
            $scope.loading = false;
          })
          .catch(function () {
            $scope.onLoadErrorText = gettextCatalog.getString('An error occurred while retrieving assets');
            $scope.onLoadErrorFlag = true;
            $scope.loading = false;
          });
      }
    }
  });
};

export const PlanAssetDeleteModalController = ($scope, $uibModalInstance) => {
  'ngInject';

  $scope.loading = false;
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.confirmed = false;

  $scope.ok = function () {
    $scope.confirmed = true;
    $uibModalInstance.close($scope.confirmed);
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
};